import { useContext} from 'react';
import { DataTravelContext } from '../context/dataTravelContext';

const useDataTravel = () => {
  const { data, promoter, loading, error, fetchData, isReservation, shouldShowDateField, isExperience  } = useContext(DataTravelContext);

  return { data, promoter, loading, error, fetchData, isReservation, shouldShowDateField, isExperience };
};

export default useDataTravel;
